var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"mt-2 mb-n2",attrs:{"dense":"","type":"info","text":""}},[_vm._v(" 赤字は最大値を意味します。ただし、集計した結果一覧の中における最大値という意味であり、過去の全データを参照しているわけではない。＝表示されている数字の中での最大値 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }